import React, { useEffect, useState } from "react";
import Translations from "../../services/translation.service";
import Settings from "../../services/settings.service";
import VMLogo from '../../assets/img/VM_logo.svg';
import Tiwiter from '../../assets/img/social/footer_twitter.svg';
import Insta from '../../assets/img/social/footer_insta.svg';
import Facebook from '../../assets/img/social/footer_fb.svg';
import YouTube from '../../assets/img/social/footer_youtube.svg';
import LinkedIN from '../../assets/img/social/footer_linkedin.svg';
import CallUs from '../../assets/img/social/CallUs.svg';

const subscriptions = [];
const StorefrontFooter = props => {
    const [translationsKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {});

    useEffect(() => {

        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, []);

    const languageConvertLink = (link) => {
        if (link && link.includes("%lang%")) {
            return link.replace("%lang%", Translations.activeLang);
        } else {
            return "#";
        }
    }

    const singlelink = (link) => {
        if (link) {
            return link;
        } else {
            return "#";
        }
    }

    const staticLanguageLink = (link, linkAR) => {
        if (Translations.activeLang === "en") {
            return link;
        }
        if (Translations.activeLang === "ar") {
            return linkAR;
        }
        return "#";
    };

    return (
        <div className="footer-container-ob">
            <div>
                <div className="footer-social-ob">
                    <div className="stay-connected-ob">
                        <span>{translationsKeys["stm_footer_stay_connected"]}</span>
                        <ul>
                            <li>
                                <a href={singlelink(Settings?.social_links?.facebook)} target="_blank" rel="noopener noreferrer">
                                    <img src={Facebook} alt="Facebook" />
                                </a>
                            </li>
                            <li>
                                <a href={singlelink(Settings?.social_links?.instagram)} target="_blank" rel="noopener noreferrer">
                                    <img src={Insta} alt="Instagram" />
                                </a>
                            </li>
                            <li>
                                <a href={singlelink(Settings?.social_links?.twitter)} target="_blank" rel="noopener noreferrer">
                                    <img src={Tiwiter} alt="Twitter" />
                                </a>
                            </li>
                            <li>
                                <a href={singlelink(Settings?.social_links?.linkdin)} target="_blank" rel="noopener noreferrer">
                                    <img src={LinkedIN} alt="Linkedin" />
                                </a>
                            </li>
                            <li>
                                <a href={singlelink(Settings?.social_links?.youtube)} target="_blank" rel="noopener noreferrer">
                                    <img src={YouTube} alt="YouTube" />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-cta-container">
                        <a href="tel:+156">
                            <div className="footer-box-cta">
                                <div>
                                    <img src={CallUs} alt={translationsKeys["stm_footer_call_us"]} />
                                </div>
                                <div>
                                    <div>{translationsKeys["stm_footer_call_us"]}</div>
                                    <div>{Settings?.call_us}</div>
                                </div>
                            </div>
                        </a>
                        {/* <a href={languageConvertLink(Settings?.get_map_stores)} target="_blank" rel="noopener noreferrer">
                            <div className="footer-box-cta">
                                <div>
                                    <img src={LocateUs} alt="Locate Us" />
                                </div>
                                <div>
                                    <div>{translationsKeys["stm_footer_locate_us"]}</div>
                                    <div>{translationsKeys["stm_footer_we_are_where_you_are"]}</div>
                                </div>
                            </div>
                        </a> */}
                    </div>
                </div>
                <div className="footer-menu-ob">
                    <div className="footer-accordion-ob">
                        <div>
                            <div>{translationsKeys["ob_footer_content_about_us"]}</div>
                        </div>
                        <ul>
                            <li><a href={languageConvertLink(Settings?.footer_links?.about_us)} target="_blank" rel="noopener noreferrer">{translationsKeys["ob_footer_content_about_us"]}</a></li>
                            <li><a href={languageConvertLink(Settings?.footer_links?.about_us)} target="_blank" rel="noopener noreferrer">{translationsKeys["ob_footer_content_our_companies"]}</a></li>
                        </ul>
                    </div>
                    <div className="footer-accordion-ob">
                        <div>
                            <div>{translationsKeys["stm_footer_content_plans_products"]}</div>
                        </div>
                        <ul>
                            <li><a href={singlelink("#")} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_plans"]}</a></li>
                            <li><a href={singlelink("#")} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_promotions"]}</a></li>
                        </ul>
                    </div>
                    <div className="footer-accordion-ob">
                        <div>
                            <div>{translationsKeys["stm_footer_help_and_support"]}</div>
                        </div>
                        <ul>
                            <li><a href={singlelink("#")} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_help_and_support"]}</a></li>
                            <li><a href={staticLanguageLink(Settings?.footer_links?.faqs, Settings?.footer_links?.faqsAR)} target="_blank" rel="noopener noreferrer">{translationsKeys["ob_footer_content_faqs"]}</a></li>
                            <li><a href={languageConvertLink(Settings?.footer_links?.contact_us)} target="_blank" rel="noopener noreferrer">{translationsKeys["ob_footer_content_contact_us"]}</a></li>
                        </ul>
                    </div>
                    {/* <div className="footer-subscribtion-ob">
                        <div>{translationsKeys["stm_footer_sign_up"]}</div>
                        <div>{translationsKeys["stm_footer_signup_and_get_latest_news"]}</div>
                    </div> */}
                </div>
                <div className="footer-copy-container-ob">
                    <div>
                        <img src={VMLogo} alt="logo" className="footer-logo-desktop" />
                        <span>{translationsKeys["stm_footer_virgin_kw_all_rights_reserved"]}</span>
                    </div>
                    <ul>
                        <li><a href={staticLanguageLink(Settings?.footer_links?.privacy, Settings?.footer_links?.privacyAR)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_privacy"]}</a></li>
                        <li><a href={staticLanguageLink(Settings?.footer_links?.terms_and_conditions, Settings?.footer_links?.terms_and_conditionsAR)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_terms_and_condition"]}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default StorefrontFooter;
